import { requestAuthAdmin, parseResponse } from './auth';

async function read(path, params, token) {
  const url = `${path}?${new URLSearchParams(params)}`;
  const response = await requestAuthAdmin(url, { method: 'GET' }, token);
  const payload = await parseResponse(response, path);
  return payload?.data ?? payload;
}
export function getUserFriends(userId, kind, page, token) {
  return read('/api-admin/v0/users/friends', { user_id: userId, kind, page, page_size: 20 }, token);
}
export function getUserAvatarLocations(userId, token) {
  return read('/api-admin/v0/users/avatar-locations', { user_id: userId }, token);
}
export function getUserPointTransactions(userId, cursor, token) {
  return read('/api-admin/v0/users/point-transactions', { user_id: userId, limit: 20, ...(cursor ? { cursor } : {}) }, token);
}
